import React, { useState } from 'react'
import "./organizations.scss"
import { GridColDef } from "@mui/x-data-grid";
import DataTable from '../../components/dataTable/DataTable.tsx'
import Add from '../../components/add/Add.tsx';

const columns: GridColDef[] = [
  { field: 'id', headerName: 'ID', width: 50 },
  {
    field: 'userAvatar', headerName: "Avatar", width: 60,
    renderCell: (params) => {
      return <img src={params.row.img || "/noavatar.png"} alt="" />
    }
  },
  { field: 'organizationName', headerName: "Gemeinde", width: 150 },
  { field: 'email', headerName: "E-Mail", width: 200 },
  { field: 'lastLogin', headerName: "letzter Login", width: 130 },
];

const rows = [
  { _id: 1, lastName: 'Stebner', firstName: 'Martin', email: 'martin.stebner@lkleer.de', userName: 'maddin', organizationName: 'LK Leer', isAdmin: true, lastLogin: '26.04.2025 10:39' },
  { _id: 2, lastName: 'Stebner', firstName: 'Martin', email: 'martin.stebner@lkleer.de', userName: 'maddin', organizationName: 'LK Leer', isAdmin: true, lastLogin: '26.04.2025 10:39' },
];

const Organizations = () => {
  const [open, setOpen] = useState(false)
  return (
    <div className="organizations">
      <div className="info">
        <h1>Organisationen</h1>
        <button onClick={() => setOpen(true)}>Neue Organisation anlegen</button>
      </div>
      <DataTable header="Organisationen" slug="organizations" columns={columns} rows={rows}/>
      {open && <Add header="Neue Organisation hinzufügen" slug='user' columns={columns} setOpen={setOpen}/>}
    </div>
  )
}

export default Organizations
